import { render, staticRenderFns } from "./PlatformShowcase.vue?vue&type=template&id=422db0d2&scoped=true"
import script from "./PlatformShowcase.vue?vue&type=script&lang=js"
export * from "./PlatformShowcase.vue?vue&type=script&lang=js"
import style0 from "./PlatformShowcase.vue?vue&type=style&index=0&id=422db0d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422db0d2",
  null
  
)

export default component.exports